import {createAsyncThunk} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {IUsersFilter} from "../../component/admin-panel/users-table-and-filtering/users-filter/UsersFilterHelper";
import UserService from "../../api/userService";

export const getUsers = createAsyncThunk(`${SliceNames.USER}/getUsers`,
    async (req: { page: number, size: number, filter: IUsersFilter, onlyWithUser: boolean }, thunkAPI) => {
        try {
            const wishId = req.filter.wishId.trim() ? req.filter.wishId : undefined
            const res = await UserService.fetchUsers(req.page, req.size, req.filter.searchText, wishId, req.filter.subscribed, req.onlyWithUser, req.filter.availablePointsMin)
            return res.data
        } catch (e) {
            return thunkAPI.rejectWithValue(e)
        }
    })

export const getPreviousLeaderboard = createAsyncThunk(`${SliceNames.USER}/getPreviousLeaderboard`,
    async (_, thunkAPI) => {
        try {
            const res = await UserService.fetchPreviousLeaderboard()
            return res.data
        } catch (e) {
            return thunkAPI.rejectWithValue(e)
        }
    })

export const getPointsHistory = createAsyncThunk(`${SliceNames.USER}/getPointsHistory`,
    async (req: { page: number, limit: number }, thunkAPI) => {
        try {
            const res = await UserService.getPointsHistory(req.page, req.limit)
            return res.data
        } catch (e) {
            return thunkAPI.rejectWithValue(e)
        }
    })